import moment from "moment";

export const getDefaultStartDate = () => {
 const firstDayOfMonth = moment().startOf('month');
 return formatDateToDatePeriod(firstDayOfMonth);
};

export const getDefaultEndDate = () => formatDateToDatePeriod(moment());

export const formatDateToDatePeriod = (date) => {
 return moment(date).format('YYYY-MM-DD');
}
